import { withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import BaseRoute from './_BaseRoute';
import AdItem from '../App/components/General/AdItem/AdItem';
import FlexWrapper from '../App/components/Layout/Flexbox/FlexWrapper';
import AdConfig from '../App/components/General/AdConfig/AdConfig';
import LotteryListingPage from '../App/modules/Lottery/components/LotteryListingPage/LotteryListingPage';


class LotteryListingRoute extends BaseRoute {
	public static async getInitialProps (state: any) {
		const reduxData = await LotteryListingRouteProps(state);

		return { reduxData };
	}

	public render () {

		return (
			<React.Fragment>

				<AdConfig
					desktopIds={[4493474]}
					mobileIds={[4493486]}
					superbannerId={4493475}
					sitebarId={4493473}
				/>

				<Header />
				<MainNavigation />

				<FlexWrapper>
					<div>
						<LotteryListingPage />

						<Footer />
					</div>

					<AdItem
						desktopAdId={4493473}
						maxHeight={600}
						maxWidth={300}
						type="side"
						className="startBelowMenuBar"
					/>
				</FlexWrapper>

			</React.Fragment>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		LotteryListingRoute,
		`lotteryListing`,
		{
			metaTitle: `Gewinnspiele in Österreich » Jetzt anmelden | Aktionsfinder`,
			metaDescription: `Aktuelle Gewinnspiele in Österreich ➜ täglich aktualisiert ✓ kostenlose Gewinnspiele ✓ attraktive Preise ✓ Jetzt anmelden & gewinnen!`,
		} as IRouteMetadataSetterType
	)
);
